// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
require("@ckeditor/ckeditor5-build-classic");

import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    ClassicEditor.create(this.element).then(editor => {
      this.editor = editor;
      const data = editor.getData();
    });
  }

  disconnect() {
    this.editor.destroy();
  }
}
